export enum userGroup {
  ADMIN = 'admin',
  REVIEWER = 'reviewer',
  USER_WO_EVENTS = 'user_wo_events',
  EVENT_REVIEWER = 'event_reviewer',
  EXTERNAL_REVIEWER = 'external_reviewer',
}
